import { FC } from 'react';
import ServiceAreasSettings from 'containers/settings/service-areas/ServiceAreasSettings';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

const ServiceAreasSettingsPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Service Areas Settings" />;
  }
  return <ServiceAreasSettings />;
};

export default ServiceAreasSettingsPage;
